import { h } from 'preact';

export const DocumentIcon = () => (
  <svg width="20" height="24" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="19.2" height="24" rx="2" fill="#97AA5C" />
    <path d="M3.19922 4.79999H12.7992" stroke="white" />
    <path d="M3.19922 8H11.1992" stroke="white" />
    <path d="M3.19922 11.2H12.7992" stroke="white" />
    <path d="M3.19922 14.4H15.9992" stroke="white" />
    <path d="M3.19922 17.6H14.3992" stroke="white" />
  </svg>
);